const eventBus = new EventTarget();

export const dispatchCustomEvent = (eventName, data) => {
  eventBus.dispatchEvent(new CustomEvent(eventName, { detail: data }));
};

export const addCustomEventListener = (eventName, callback) => {
  eventBus.addEventListener(eventName, callback);

  return () => {
    eventBus.removeEventListener(eventName, callback);
  };
};

export const eventNames = {
  resetCart: 'resetCart'
};
